import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useDrawerStore } from '@/stores/drawerStore';

/**
 * CompletedView
 * 送信完了画面
 */
export function CompletedView() {
  const { closeDrawer } = useDrawerStore();

  return (
    <div className="flex-1 flex flex-col items-center justify-center p-4 sm:p-6 lg:p-8">
      <div className="max-w-md text-center space-y-6 sm:space-y-8">
        {/* Success Icon */}
        <div className="flex justify-center">
          <div className="w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 bg-[#10B981] rounded-full flex items-center justify-center">
            <Check className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 text-white" strokeWidth={3} />
          </div>
        </div>

        {/* Heading */}
        <div className="space-y-2 sm:space-y-3">
          <h2 className="text-[#111827] text-xl sm:text-2xl lg:text-[28px] font-bold leading-tight">
            無料提案の依頼が完了しました
          </h2>
          <p className="text-[#6B7280] text-sm sm:text-base leading-relaxed">
            ご登録のメールアドレス宛に、30分以内に提案資料をお届けいたします。
          </p>
        </div>

        {/* Close Button */}
        <Button
          onClick={closeDrawer}
          variant="outline"
          className="w-full border-2 border-[#E5E7EB] hover:bg-[#F9FAFB] text-[#111827] rounded-lg transition-all text-sm sm:text-base font-semibold h-11 sm:h-12"
        >
          閉じる
        </Button>
      </div>
    </div>
  );
}
